import { createContext, useContext, useState } from "react";
import { OverridableComponent } from "@material-ui/core/OverridableComponent";
import { SvgIconTypeMap } from "@material-ui/core/SvgIcon";
import { Home } from "@material-ui/icons";

type BreadcrumbType = {
    label: string;
    path: string;
    icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">>
};

type BreadcrumbContextType = {
    breadcrumbs: Array<BreadcrumbType>;
    setBreadcrumbs: React.Dispatch<React.SetStateAction<Array<BreadcrumbType>>>;
};

const BreadcrumbContext = createContext<BreadcrumbContextType>({
    breadcrumbs: [],
    setBreadcrumbs: () => { },
});

const defaultBreadcrumb = {
    label: "Home",
    path: "/admin",
    icon: Home
};

export default function BreadcrumbProvider({ children }: { children: React.ReactNode }) {
    const [breadcrumbs, setBreadcrumbs] = useState<Array<BreadcrumbType>>([defaultBreadcrumb]);

    return (
        <BreadcrumbContext.Provider
            value={{
                breadcrumbs,
                setBreadcrumbs
            }}
        >
            {children}
        </BreadcrumbContext.Provider>
    );
}

export function useBreadcrumbs() {
    return useContext(BreadcrumbContext);
}
